<ng-container [formGroup]="productForm">
  <div>
    <mat-form-field appearance="fill">
      <mat-label>Nom du produit</mat-label>
      <input
        data-test="productNameInput"
        matInput
        formControlName="name"
        required
      />
    </mat-form-field>
  </div>
  <div>
    <mat-form-field appearance="fill">
      <mat-label>Description</mat-label>
      <textarea
        data-test="productDescriptionInput"
        matInput
        matTooltip="Soyez le plus détaillés possible pour permettre aux acheteurs de faire un choix éclairé. Au besoin, consultez notre FAQ vendeurs dans la section Produits"
        cdkTextareaAutosize
        cdkAutosizeMinRows="2"
        formControlName="description"
        required
      ></textarea>
      <mat-error *ngIf="productForm.controls.description.invalid"
        >Une description minimale est requise
      </mat-error>
    </mat-form-field>
  </div>
  <br />
  <div>
    <mat-form-field appearance="fill">
      <mat-label>Prix</mat-label>
      <input
        data-test="productPriceInput"
        matInput
        matTooltip="Le prix minimum est actuellement de 2 $ ou gratuit. Choisissez un prix qui vous semble juste pour votre travail. Ne sous-estimez pas sa valeur"
        type="number"
        min="2.00"
        step="0.01"
        formControlName="price"
        required
      />
    </mat-form-field>
  </div>
  <div>
    <mat-checkbox data-test="productFreeInput" formControlName="free"
      >Gratuit
    </mat-checkbox>
    <br />
  </div>
  <div>
    <br />
    <mat-label>Catégories</mat-label>
    <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
      <!-- This is the tree node template for leaf nodes -->
      <mat-tree-node
        *matTreeNodeDef="let node"
        matTreeNodeToggle
        matTreeNodePadding
      >
        <!-- use a disabled button to provide padding for tree leaf -->
        <button type="button" mat-icon-button disabled></button>
        <mat-checkbox
          data-test="categoryCheckbox"
          class="checklist-leaf-node"
          (change)="categoryLeafItemSelectionToggle(node)"
          [checked]="checklistSelection.isSelected(node)"
          >{{ node.name }}</mat-checkbox
        >
      </mat-tree-node>
      <!-- This is the tree node template for expandable nodes -->
      <mat-tree-node
        *matTreeNodeDef="let node; when: hasChild"
        matTreeNodePadding
      >
        <button
          type="button"
          data-test="categoryExpandButton"
          mat-icon-button
          matTreeNodeToggle
          [attr.aria-label]="'Toggle ' + node.name"
        >
          <mat-icon class="mat-icon-rtl-mirror">
            {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
          </mat-icon>
        </button>
        {{ node.name }}
      </mat-tree-node>
    </mat-tree>
  </div>
  <br />
  <app-image-upload
    formControlName="imagesInput"
    [multiple]="true"
  ></app-image-upload>
  <br />
  <app-file-upload
    [fileNames]="fileNames"
    formControlName="filesInput"
  ></app-file-upload>
</ng-container>
